var _g, _g2, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSection22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 97,
    viewBox: "0 0 60 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1197_1928)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.28711,
    width: 55,
    height: 91.4286,
    rx: 9.64286,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_1197_1928)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.35669,
    y: 5.13672,
    width: 49.2857,
    height: 85.7143,
    rx: 6.78571,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.857 41.2129V41.22M23.9285 41.57C23.9285 40.8123 24.2295 40.0855 24.7653 39.5497C25.3011 39.0139 26.0278 38.7129 26.7856 38.7129H32.4999C33.2577 38.7129 33.9844 39.0139 34.5202 39.5497C35.056 40.0855 35.357 40.8123 35.357 41.57V47.2843C35.357 48.0421 35.056 48.7688 34.5202 49.3046C33.9844 49.8404 33.2577 50.1415 32.4999 50.1415H26.7856C26.0278 50.1415 25.3011 49.8404 24.7653 49.3046C24.2295 48.7688 23.9285 48.0421 23.9285 47.2843V41.57ZM27.4999 44.4272C27.4999 44.9955 27.7257 45.5405 28.1275 45.9424C28.5294 46.3443 29.0744 46.57 29.6428 46.57C30.2111 46.57 30.7561 46.3443 31.158 45.9424C31.5598 45.5405 31.7856 44.9955 31.7856 44.4272C31.7856 43.8589 31.5598 43.3138 31.158 42.9119C30.7561 42.5101 30.2111 42.2843 29.6428 42.2843C29.0744 42.2843 28.5294 42.5101 28.1275 42.9119C27.7257 43.3138 27.4999 43.8589 27.4999 44.4272Z",
    stroke: "#6452ED",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.1429,
    cy: 13.3583,
    rx: 3.92857,
    ry: 3.92857,
    fill: "#FAC900"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.4997,
    cy: 83.0022,
    rx: 2.14286,
    ry: 2.14286,
    fill: "#191919"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.9283,
    cy: 83.0022,
    rx: 2.14286,
    ry: 2.14286,
    fill: "#191919"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.3568,
    cy: 83.0022,
    rx: 2.14286,
    ry: 2.14286,
    fill: "#191919"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.7854,
    cy: 83.0022,
    rx: 2.14286,
    ry: 2.14286,
    fill: "#191919"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.9285,
    y: 11.5781,
    width: 19.2857,
    height: 3.21428,
    rx: 1.60714,
    fill: "#191919"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1197_1928",
    x: 0.892857,
    y: 0.679967,
    width: 58.2143,
    height: 95.7134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07143
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.803571
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.168 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1197_1928"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.803571
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.084 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1197_1928",
    result: "effect2_dropShadow_1197_1928"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1197_1928",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_1197_1928",
    x: 3.74955,
    y: 3.52958,
    width: 52.5001,
    height: 90.0006,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07143
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.803571
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.168 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1197_1928"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.803571
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.084 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1197_1928",
    result: "effect2_dropShadow_1197_1928"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1197_1928",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection22);
export default __webpack_public_path__ + "static/media/section2-2.e6fa7d1613073e0aaeb1dead56a26841.svg";
export { ForwardRef as ReactComponent };